import { useState } from "react";
import CreatableSelect from "react-select/creatable";
import { IoClose } from "react-icons/io5";

const selectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: "34px",
        height: "34px",
        fontSize: "0.875rem",
        borderColor: state.isFocused ? "#3b82f6" : "#d1d5db",
        boxShadow: "none",
        "&:hover": { borderColor: "#3b82f6" },
    }),

    valueContainer: (base) => ({
        ...base,
        padding: "0 6px",
        fontSize: "0.875rem",
    }),

    input: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
        fontSize: "0.875rem",
    }),

    singleValue: (base) => ({
        ...base,
        fontSize: "0.875rem",
    }),

    placeholder: (base) => ({
        ...base,
        fontSize: "0.875rem",
    }),

    indicatorsContainer: (base) => ({
        ...base,
        height: "34px",
    }),

    dropdownIndicator: (base) => ({
        ...base,
        padding: "0 6px",
    }),

    clearIndicator: (base) => ({
        ...base,
        padding: "0 6px",
    }),

    menuPortal: (base) => ({
        ...base,
        zIndex: 9999,
    }),

    menu: (base) => ({
        ...base,
        zIndex: 9999,
        fontSize: "0.875rem",
    }),

    option: (base, { isFocused }) => ({
        ...base,
        fontSize: "0.875rem",
        backgroundColor: isFocused ? "#EFF6FF" : "white",
        color: "#111827",
    }),
};

const RenameRecipeModal = ({
    recipe,
    foodMenuItems,
    beverageMenuItems,
    onConfirm,
    onClose,
}) => {
    const [selected, setSelected] = useState(null);

    const itemList =
        recipe?.ItemType?.toLowerCase() === "beverage"
            ? beverageMenuItems
            : foodMenuItems;

    const options = (itemList || []).map((name) => ({
        value: name,
        label: name,
    }));

    const handleConfirm = () => {
        if (!selected?.value?.trim()) return;
        onConfirm(recipe, selected.value.trim());
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
            <div className="bg-white rounded-lg shadow-xl w-[420px] p-4">

                {/* Header */}
                <div className="flex items-center justify-between mb-3">
                    <div className="text-base font-semibold text-gray-800">Rename Recipe</div>
                    <button
                        onClick={onClose}
                        className="rounded-lg p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition"
                    >
                        <IoClose size={18} />
                    </button>
                </div>

                {/* Current name */}
                <div className="mb-4">
                    <label className="block text-xs font-medium text-gray-500 mb-1 uppercase tracking-wide">
                        Current Name
                    </label>
                    <div className="px-3 py-2 rounded-md border border-gray-200 bg-gray-50 text-sm text-gray-700 font-medium">
                        {recipe?.name}
                    </div>
                </div>

                {/* New name */}
                <div className="mb-6">
                    <label className="block text-xs font-medium text-gray-500 mb-1 uppercase tracking-wide">
                        New Name
                    </label>
                    <CreatableSelect
                        options={options}
                        value={selected}
                        onChange={setSelected}
                        onCreateOption={(inputValue) =>
                            setSelected({ value: inputValue, label: inputValue })
                        }
                        placeholder="Select or type a new name..."
                        isClearable
                        styles={selectStyles}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        autoFocus
                    />
                    <p className="mt-1 text-xs text-gray-400">
                        Pick from the list or type to create a custom name.
                    </p>
                </div>

                {/* Actions */}
                <div className="flex justify-end gap-2 border-t pt-4">
                    <button
                        onClick={onClose}
                        className="px-4 py-1.5 rounded-md border border-gray-300 bg-white text-sm text-gray-700 font-medium hover:bg-gray-50 transition"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleConfirm}
                        disabled={!selected?.value?.trim()}
                        className="px-4 py-1.5 rounded-md bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition"
                    >
                        Rename
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RenameRecipeModal;